const UPLOADS_PREFIX = (process.env.REACT_APP_UPLOADS_PUBLIC_PREFIX || '/app/uploads').replace(/\/$/, '');

export function isPdfPath(path: string | null | undefined): boolean {
    if (!path || path === '-') {
        return false;
    }
    const clean = path.split('?')[0].split('#')[0];
    return /\.pdf$/i.test(clean);
}

function extractBasename(path: string): string {
    const normalized = path.replace(/\\/g, '/');
    const withoutQuery = normalized.split('?')[0].split('#')[0];
    const parts = withoutQuery.split('/').filter(Boolean);
    return parts[parts.length - 1] || withoutQuery;
}

function normalizeUploadPathname(pathname: string): string {
    if (pathname.startsWith('/app/uploads/')) {
        return pathname;
    }
    const uploadsIdx = pathname.indexOf('/uploads/');
    if (uploadsIdx >= 0) {
        return `/app${pathname.slice(uploadsIdx)}`;
    }
    if (pathname.startsWith('/uploads/')) {
        return `/app${pathname}`;
    }
    return pathname;
}

export function resolveUploadFileUrl(path: string | null | undefined): string {
    if (!path || path === '-') {
        return '';
    }

    const trimmed = path.trim();
    if (!trimmed) {
        return '';
    }

    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        try {
            const url = new URL(trimmed);
            if (url.pathname.includes('/uploads/') || url.pathname.includes('/app/uploads/')) {
                return normalizeUploadPathname(url.pathname);
            }
            return trimmed;
        } catch {
            return trimmed;
        }
    }

    if (trimmed.startsWith('/app/uploads/')) {
        return trimmed;
    }

    if (trimmed.includes('/uploads/')) {
        return normalizeUploadPathname(trimmed.startsWith('/') ? trimmed : `/${trimmed}`);
    }

    const basename = extractBasename(trimmed);
    return `${UPLOADS_PREFIX}/${basename}`;
}
